import * as Blockly from 'blockly/core';
import type { CategoryId } from './categories';

/**
 * Single source of truth for every custom block in the studio.
 * The toolbox, the AI tool manifest, and the docs all read from this registry;
 * a block that is not registered here cannot be created by any consumer.
 */

export type FieldKind =
  | { kind: 'dropdown'; options: string[] }
  | { kind: 'number' }
  | { kind: 'text' }
  | { kind: 'boolean' }
  | { kind: 'value'; types: string };

export interface BlockMeta {
  type: string;
  category: CategoryId;
  label: string;
  description: string;
  fields: Record<string, FieldKind>;
  /** Name of the statements input for hat / C-shaped blocks. */
  statementInput?: string;
  /** True for hat blocks (no previous connection, event-driven). */
  hat?: boolean;
}

const registry = new Map<string, BlockMeta>();

export interface Registration {
  /** Blockly JSON block definitions. */
  definitions: Record<string, unknown>[];
  metas: BlockMeta[];
}

export function registerBlocks(registration: Registration): void {
  Blockly.defineBlocksWithJsonArray(registration.definitions as never);
  for (const meta of registration.metas) {
    registry.set(meta.type, meta);
  }
}

export function getBlockMeta(type: string): BlockMeta | undefined {
  return registry.get(type);
}

export function getAllBlockMeta(): BlockMeta[] {
  return [...registry.values()];
}

export function blockCategory(type: string): CategoryId | undefined {
  return registry.get(type)?.category;
}
